/* unplugin-vue-components disabled */import { render } from "./UploadManyImage.vue?vue&type=template&id=6499b5d8"
import script from "./UploadManyImage.vue?vue&type=script&lang=js"
export * from "./UploadManyImage.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\arc_frontend\\arctenantorg\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__